// const headerStyle = () => {
//     if( $(window).scrollTop() > 2 ) {
//         $('.header').addClass('header--fixed');
//     } else {
//         $('.header').removeClass('header--fixed');
//     }
// }

// $(document).on('scroll ready', function(){
//     headerStyle();
// })

$('.dropdown-menu .nav-item .nav-link').each( function() {
    $(this).prepend('<div class="nav-link__icon"><i class="icon icon-arrow-right"></i></div>');
});

// if (window.innerWidth < 767) {
//     $('.header__button').attr('href', 'tel:0408425100');
// }
